import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RegCosting } from 'shared/models/regcosting';
import { RegTableService } from './reg-table.service';

@Component({
  selector: 'app-reg-table',
  templateUrl: './reg-table.component.html',
  styleUrls: ['./reg-table.component.scss']
})
export class RegTableComponent implements OnInit {
  regCosting: RegCosting[];
  columns: any[];

  constructor(private regTableService: RegTableService) { }

  ngOnInit(): void {
    this.regTableService.getRegCostingDetails().then((res: any) => this.regCosting = res);
    this.columns = [
      { field: 'phase', header: 'Phase' },
      { field: 'year', header: 'Year' },
      { field: 'cost', header: 'Cost in $' }
    ];
  }
  @Input() name: string;
  @Output() callenableBeStudyTabFunc: EventEmitter<any> = new EventEmitter<any>();

  onClickNext() {
    this.callenableBeStudyTabFunc.emit();
  }

}
